import React from 'react';
import { PasswordChangePageStyle as S } from './PasswordChangePage.style';
import { PasswordChangePageBLoC as BLoC } from './PasswordChangePage.bloc';
import { LeftPanelPageBase } from 'components/layouts/LeftPanelPageBase/LeftPanelPageBase';
import { PasswordsChangeForm } from './components/PasswordsChangeForm/PasswordsChangeForm';

export const PasswordChangePage: React.FC = () => {
  return (
    <BLoC>
      {() => (
        <LeftPanelPageBase breadCrumbs="hidden" hideLeftPanel>
          <S.Container>
            <S.Title>Create new password</S.Title>
            <S.AltText>
              For security reasons, we will log you out of all other devices once you set your new password.
              We recommend using a unique passphrase <span className="underline">at least 20 characters</span>{' '}
              in length and enabling multi-factor authentication.
            </S.AltText>
            <PasswordsChangeForm />
          </S.Container>
        </LeftPanelPageBase>
      )}
    </BLoC>
  );
};
